import { render, staticRenderFns } from "./CategoryMainCard.vue?vue&type=template&id=f933f3e0&scoped=true"
import script from "./CategoryMainCard.vue?vue&type=script&lang=js"
export * from "./CategoryMainCard.vue?vue&type=script&lang=js"
import style0 from "./CategoryMainCard.vue?vue&type=style&index=0&id=f933f3e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f933f3e0",
  null
  
)

export default component.exports